import { ISelectOption } from "../Components/Utils/MultiSelect/MultiSelect";

export type User = {
    id: string;
    sub: string;
    crispId: string;
    archived: boolean;
    likedTemplateIds: string[];
    email: string;
    givenName?: string;  // Optional properties can be marked with a "?".
    familyName?: string;
    fullName?: string;
    picture?: string;
    lastLogin: Date;
    receiveEmails: boolean;
}

export type UserDisplay = {
    sub: string;
    fullName: string;
}

// available users -> dropdown options
export const mapUsersToSelectOptions = (users: UserDisplay[]): ISelectOption[] =>
  users.map((u) => ({
    value: u.sub,
    label: u.fullName,
    required: false,
  }));

// assignedTo (UserDisplay[]) -> selectedOptions (ISelectOption[])
export const mapAssignedUsersToSelectOptions = (
  assigned: UserDisplay[] | undefined
): ISelectOption[] =>
  (assigned ?? []).map((u) => ({
    value: u.sub,
    label: u.fullName,
    required: false,
  }));

// selectedOptions (ISelectOption[]) -> assignedTo (UserDisplay[])
// Uses availableUsers to rebuild real UserDisplay objects.
// Falls back to {sub, fullName} if not found.
export const mapSelectOptionsToAssignedUsers = (
  opts: ISelectOption[],
  availableUsers: UserDisplay[]
): UserDisplay[] => {
  const bySub = new Map(availableUsers.map((u) => [u.sub, u]));

  return opts.map((o) => {
    const match = bySub.get(o.value);
    return match ?? { sub: o.value, fullName: o.label };
  });
};

export const mapAssignedUsersToSelectOptionsFromAvailable = (
  assigned: UserDisplay[] | undefined,
  available: UserDisplay[]
): ISelectOption[] => {
  if (!assigned?.length) return [];

  const bySub = new Map(available.map(u => [u.sub, u.fullName]));
  return assigned.map(u => ({
    value: u.sub,
    label: bySub.get(u.sub) ?? u.fullName,
    required: false
  }));
};
